import { createBrowserRouter } from 'react-router-dom';
import AppRoutes from './app-routes';

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  {
    path: '*',
    Component: AppRoutes,
  },
]);

export default router;
